import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { middlewares as serviceMiddlewares } from '~/data/api/client/reducer'

import reducer from './reducers'
import { cloakingCacheMiddleware } from './slices/currentOrg'

const persistConfig = {
  key: 'root',
  storage,
  // demoMode is persisted on purpose: a mid-demo tab refresh must come back still anonymized.
  whitelist: ['v2-dashboard', 'reports', 'tenant', 'demoMode']
}

/** The localStorage key redux-persist writes the whitelisted slices under. */
export const PERSIST_ROOT_STORAGE_KEY = `persist:${persistConfig.key}`

const persistedReducer = persistReducer(persistConfig, reducer) as unknown as typeof reducer

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(...serviceMiddlewares, cloakingCacheMiddleware)
})
export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
